import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import DefaultHeader from "../components/headers/DefaultHeader";
import Footer from "../../erp/components/Footer";

import defaultRoutes from "../../erp/routes/DefaultRoutes";

import pagesStyle from "../../assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";

import bgImage from "../../assets/img/loginbg.png";

class Pages extends React.Component {
    componentDidMount() {
        document.body.style.overflow = "unset";
    }
    render() {
        const { classes, ...rest } = this.props;
        
        return (
            <div>
                <DefaultHeader {...rest} />
                <div className={classes.wrapper} ref="wrapper">
                    <div
                        className={classes.fullPage}
                        style={{ backgroundImage: "url(" + bgImage + ")" }}
                    >
                        <Switch>
                            {defaultRoutes.map((prop, key) => {
                                if (prop.collapse) {
                                    return null;
                                }
                                if (prop.redirect) {
                                    return (
                                        <Redirect from={prop.path} to={prop.pathTo} key={key} />
                                    );
                                }
                                return (
                                    <Route
                                        path={prop.path}
                                        component={prop.component}
                                        key={key}
                                    />
                                );
                            })}
                        </Switch>
                        <Footer white />
                    </div>
                </div>
            </div>
        );
    }
}

Pages.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(pagesStyle)(Pages);



// WEBPACK FOOTER //
// ./src/erp/layouts/DefaultLayout.js